// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"29f0d401","833":"113c7793","854":"3169d73d"}[chunkId] + ".chunk.js";
};